import { useLocation, useNavigate } from 'react-router-dom';
import { AppRoutePaths } from '../../../../helpers/Routes';
import type { SavedSessionTrySaveHook } from './SavedSessionTrySave.types';

/**
 * Hook exposing `trySave`, which initiates the saved session save flow by
 * navigating to the SaveSession route. The current pathname is passed as
 * `state.from` so the user can be returned to their original location after
 * the save flow completes.
 */
export const useSavedSessionTrySave: SavedSessionTrySaveHook = () => {
    const location = useLocation();
    const navigate = useNavigate();

    return {
        trySave: async () => {
            navigate(
                AppRoutePaths.SaveSession,
                {
                    state: {
                        from: location.pathname,
                    },
                },
            );
        },
    };
};